import L from 'leaflet'
import { ref } from 'vue'

export default class MapLayer {
    constructor (name = 'unknown') {
        this.name = name
        this.isBackgroundLayer = true
        this.isDefaultEnabled = false
        this._isEnabled = ref(false)
        this._map = null
        this._layers = null
    }

    get isEnabled () {
        return this._isEnabled.value
    }

    render () {
        return []
    }

    addToMap (map) {
        this._map = map
        if (this.isDefaultEnabled) this.enable()
        return this
    }

    enable () {
        if (this._isEnabled.value) return
        this._getLayers()
            .forEach(layer => {
                this._map.addLayer(layer)
                if (this.isBackgroundLayer) layer.bringToBack()
            })
        this._isEnabled.value = true
        return this
    }

    disable () {
        if (this._isEnabled.value === false) return
        this._getLayers()
            .forEach(layer => {
                this._map.removeLayer(layer)
            })
        this._isEnabled.value = false
        return this
    }

    _getLayers () {
        if (!this._layers) {
            const layers = this.render()
            this._layers = Array.isArray(layers) ? layers : [layers]
        }
        return this._layers
    }
}

